import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PENDING_BILL_NUDGE } from 'src/defaultImages.js';
import { CollectionInfrastructureHelperService } from '../../collection-infrastructure-helper.service';
import { UtilService } from 'src/app/util/util.service';

@Component({
  selector: 'app-infra-nudge',
  templateUrl: './infra-nudge.component.html',
  styleUrls: ['./infra-nudge.component.css'],
})
export class InfraNudgeComponent implements OnInit {
  images: any = {
    PENDING_BILL_NUDGE,
  };
  isNegative: boolean = false;
  isPlanExpired:boolean = false;
  @Output() dismissNudge: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _ciHelperService: CollectionInfrastructureHelperService,
  ) {}

  ngOnInit() {
    this.isNegative =this._ciHelperService.isNegativeBalance();
    this.isPlanExpired = this._ciHelperService.isPlanExpired();
  }

  dismissInfraNudge() {
    this.dismissNudge.emit();
  }

  renew() {
    this._ciHelperService.redirectToSubscriptionPage();
    if(!this.isPlanExpired)
      {
        this.dismissInfraNudge();
      }
}}
